const Config = {
  'Recycle.hedgetag': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'value_protection',
    },
    iid: {
      type: 'variable',
      func: ({ trade_in_model }) => `trade_in_model=${trade_in_model}`,
    },
  },
  'Recycle.changeold': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'model_old',
    },
    iid: {
      type: 'variable',
      func: ({ trade_in_model, trade_in_type }) =>
        `trade_in_model=${trade_in_model}${trade_in_type ? `&trade_in_type=${trade_in_type}` : ''}`,
    },
  },
  'Recycle.applyrights': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'apply_benefit',
    },
    iid: {
      type: 'variable',
      func: ({ trade_in_model, trade_in_type, pop_name }) =>
        `trade_in_model=${trade_in_model}${
          trade_in_type ? `&trade_in_type=${trade_in_type}` : ''
        }&pop_name=${pop_name}`,
    },
  },
  'Recycle.changenew': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'replacement_specification',
    },
    iid: {
      type: 'variable',
      func: ({ trade_in_model, trade_in_type }) => `trade_in_model=${trade_in_model}&trade_in_type=${trade_in_type}`,
    },
  },
  'Recycle.channelConfirm': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'replacement_channel_confirm',
    },
    iid: {
      type: 'variable',
      func: ({ trade_in_model, trade_in_type }) => `trade_in_model=${trade_in_model}&trade_in_type=${trade_in_type}`,
    },
  },
  'Recycle.revaluation': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'afresh_valuation',
    },
    iid: {
      type: 'variable',
      func: ({ trade_in_model }) => `trade_in_model=${trade_in_model}`,
    },
  },
  'Recycle.hedgededuction': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'value_protection_credit',
    },
    iid: {
      type: 'variable',
      func: ({ trade_in_model }) => `trade_in_model=${trade_in_model}`,
    },
  },
  'Recycle.channel.newdevicetag': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'channel_new_device_tag',
    },
    iid: {
      type: 'variable',
      func: ({ new_device_tag_type, new_device_tag_id }) =>
        `new_device_tag_type=${new_device_tag_type}&new_device_tag_id=${new_device_tag_id}`,
    },
  },
  'Recycle.channel.newdevice': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'channel_new_device',
    },
    iid: {
      type: 'variable',
      func: ({ new_device_type, new_device_index }) =>
        `new_device_type=${new_device_type}&new_device_index=${new_device_index}`,
    },
  },
  'Recycle.deleteold': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'delete_old',
    },
  },
  'Recycle.recyclelocate': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'recycle_locate',
    },
  },
  'Recycle.recycletype': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'recycle_type',
    },
  },
  'Recycle.tradetype': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'trade_type',
    },
  },
  'Recycle.recyclestore': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'recycle_store',
    },
  },
  'Recycle.recycletime': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'recycle_time',
    },
  },
  'Recycle.tradeclose': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'trade_close',
    },
  },
  'Recycle.tradereturn': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'trade_return',
    },
  },
  'Recycle.tradesubmit': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'trade_submit',
    },
    iid: {
      type: 'variable',
      func: ({ trade_type }) => `trade_type=${trade_type}`,
    },
  },
  'Recycle.recyclestoretel': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'recycle_store_tel',
    },
    iid: {
      type: 'variable',
      func: ({ store_id }) => `store_id=${store_id}`,
    },
  },
  'Recycle.recyclestorelist': {
    operation: ['VISIBLE'],
    getParse: {
      type: 'variable',
      func: (item, data, { pageName }) => {
        return [
          {
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            d: item.index + 1,
            c: 'recycle_store_list',
            iid: `store_id=${item?.item?.id}`,
          },
        ];
      },
    },
  },
  'Recycle.recyclestorelist.touch': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'recycle_store_list',
    },
    d: {
      type: 'variable',
      func: ({ d }) => d,
    },
    iid: {
      type: 'variable',
      func: ({ store_id }) => `store_id=${store_id}`,
    },
  },
  'Recycle.recycletimepop': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'recycle_time_pop',
    },
    iid: {
      type: 'variable',
      func: ({ time }) => `time=${time}`,
    },
  },
  'Recycle.recycleaddress': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'recycle_address',
    },
    iid: {
      type: 'variable',
      func: ({ address_id }) => `address_id=${address_id}`,
    },
  },
  'Recycle.poppostrecycle': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'pop_post_recycle',
    },
  },
  'Recycle.popchangeaddress': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'pop_change_address',
    },
  },
  'Recycle.poprebuy': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'pop_rebuy',
    },
  },
  'Recycle.onsitetime': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'on_site_time',
    },
    iid: {
      type: 'variable',
      func: ({ time }) => `time=${time}`,
    },
  },
};

export default Config;
